import BaseCollection from '@/helpers/baseCollection.js'

export default class SystemLanguageCollection extends BaseCollection {
	url = 'systemlanguages'
}
